import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { parseCleanupErrorEntry } from '../tenantHelpers';

const CleanupResultModal = ({ errors, isOpen, onClose }) => {
  if (!isOpen || !errors?.length) return null;

  const entries = errors.map(parseCleanupErrorEntry);

  return (
    <div className="stm-modal-overlay" onClick={onClose}>
      <div className="stm-modal stm-modal--sm" onClick={(event) => event.stopPropagation()}>
        <header className="stm-modal__header">
          <div>
            <h2>Cleanup completed with issues</h2>
            <p>Some tenants could not be cleaned</p>
          </div>
          <button type="button" className="stm-icon-btn" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </header>
        <div className="stm-modal__body">
          <ul className="stm-result-list stm-result-list--cleanup">
            {entries.map((entry) => (
              <li key={entry.label}>
                <strong>{entry.label}</strong>
                <span>{entry.reason}</span>
              </li>
            ))}
          </ul>
        </div>
        <footer className="stm-modal__footer">
          <button type="button" className="stm-btn stm-btn--primary" onClick={onClose}>Close</button>
        </footer>
      </div>
    </div>
  );
};

export default CleanupResultModal;
